import { ComponentConfig } from '@measured/puck';
import 'react-quill-new/dist/quill.snow.css';
import { QuillTextEditor } from '../../../page-builder/puck/reusable-props/quill-editor';
import CustomTooltip from '../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../services/constants';
import {
  marginFields,
  MarginProps,
} from '../../../page-builder/puck/reusable-props/margin';
import { paddingFields, PaddingProps } from '../../puck/reusable-props/padding';
import './style.scss';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type TextEditorProps = {
  content: string;
  border: IBorderValueProps;
  background: {
    color: string;
    isInherit: boolean;
  };
} & PaddingProps &
  MarginProps &
  showComponentProps;

export const TextEditor = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<TextEditorProps> => {
  return {
    label: (
      <CustomTooltip title="TextEditor">
        <span>Text Editor</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      content: {
        ...QuillTextEditor('Content').content,
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      content:
        '<p style="line-height:1.5;"><span style="font-size: 16px;">Text Editor</span></p>',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      ...borderProps,
    },
    render: ({
      content,
      margin,
      padding,
      showComponent,
      editMode,
      border,
      background,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      const state = useAppSelector(state => state);

      // for future use
      // const cartData = useAppSelector(state => state.cart?.cartData);
      // const [searchParams] = useSearchParams();
      // const processContent = (text: string) => {
      //   // Regular expression to match the content within {isVIP && ...}
      //   const vipContentPattern = /<p>{isVIP\s*&amp;&amp;\s*([^}]+)}<\/p>/g;
      //   const showVIPContent =
      //     cartData?.HasSubscription ||
      //     searchParams.get('cart') == 'PHOENIX_CART_PREVIEW' ||
      //     getIsViewIsEdit();
      //   // If VIP, replace the placeholder with the actual content
      //   if (showVIPContent) {
      //     return text.replace(
      //       vipContentPattern,
      //       (_, content) => `<p>${content.trim()}</p>`,
      //     );
      //   }

      //   // If not VIP, remove the content within {isVIP && ...}
      //   return getQuillEditorText(text.replace(vipContentPattern, ''), state);
      // };

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType),
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
                lineHeight: 1.5,
              }}
              className={`text-editor-content remove-line-height ${border?.borderStyle?.[currentDeviceType]}`}
              dangerouslySetInnerHTML={{
                __html: getQuillEditorText(content, state),
              }}
            />
          )}
        </>
      );
    },
  };
};
